export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const timeOutSec = 10;

export const RES_PER_PAGE = 10;

export const KEY = 'd794df55-16aa-4012-924e-550a68bcdedd';

export const MODAL_CLOSE_SEC = 3.5;
